<template>
  <div class="filtros pb-2">
    <details class="simple" open>
      <summary>FILTROS DE ANÁLISIS</summary>
      <b-row>
        <b-col lg="3">
          <b-form-group label="Unidad de negocio">
            <combo-multiple
              v-model="filtros.unidadesNegocio"
              @selected="onUnidadesNegocioChanged"
              :options="maestros.unidadesNegocio"
              placeholder="Seleccione unidad(es) de negocio"
              class="input-mw filter"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Países">
            <combo-multiple
              v-model="filtros.paises"
              placeholder="Seleccione país(es)"
              :options="maestros.paises"
              class="input-mw filter"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Cliente">
            <select-box
              :url="`clientes/autocompletar&unidadesNegocio=${filtros.unidadesNegocio}&paises=${filtros.paises}`"
              placeholder="Seleccione cliente"
              v-model="filtros.clienteId"
              class="input-mw filter"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Búsqueda">
            <b-form-input
              v-model="filtros.busqueda"
              class="input-mw filter"
              type="search"
              placeholder="Búsqueda rápida"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Segunda fila de filtros -->
      <b-row>
        <b-col lg="3">
          <b-form-group label="Campañas">
            <combo-multiple
              placeholder="Seleccione campaña(s)"
              v-model="filtros.campanias"
              class="input-mw filter"
              :options="maestros.campanias"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Tipo de venta">
            <combo-multiple
              placeholder="Seleccione tipo(s) de venta"
              v-model="filtros.tiposDeVenta"
              class="input-mw filter"
              :options="maestros.tiposDeVenta"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Origen">
            <combo-multiple
              placeholder="Seleccione origen(es)"
              v-model="filtros.origenes"
              class="input-mw filter"
              :options="maestros.origenes"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Propietarios">
            <combo-multiple
              placeholder="Seleccione propietario(s)"
              v-model="filtros.propietarios"
              class="input-mw filter"
              :options="maestros.propietarios"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- El embudo y la etapa quedan ocultos de momento -->
        <!-- <b-col lg="3">
          <b-form-group label="Embudo pipedrive">
            <combo-multiple
              v-model="filtros.embudos"
              class="input-mw filter"
              :options="maestros.embudos"
            />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label="Etapa pipedrive">
            <combo-multiple
              v-model="filtros.etapas"
              class="input-mw filter"
              :options="maestros.etapas"
            />
          </b-form-group>
        </b-col> -->

        <!-- El estado de pipedrive queda oculto de momento -->
        <!-- <b-col lg="3">
            <b-form-group label="Estado pipedrive">
              <combo-multiple
                class="input-mw filter"
                v-model="filtros.estadosPipedrive"
                :options="maestros.estadosPipedrive"
              />
            </b-form-group>
          </b-col> -->

        <!-- Sector -->
        <b-col lg="3">
          <b-form-group label="Sector">
            <combo-multiple
              placeholder="Seleccione sector(es)"
              class="input-mw filter"
              v-model="filtros.sectores"
              :options="maestros.sectores"
            />
          </b-form-group>
        </b-col>

        <!-- Fecha de estado -->
        <b-col lg="3">
          <b-form-group label="Fecha estado">
            <date-picker
              v-model="filtros.fecha"
              class="filter"
              format="MM-YYYY"
              type="month"
              range
              placeholder="Elija fecha de estado"
            />
          </b-form-group>
        </b-col>

        <!-- Fecha oferta -->
        <!--
        <b-col lg="3">
          <b-form-group label="Fecha Oferta">
            <date-picker
              v-model="filtros.fechaOferta"
              class="filter"
              format="MM-YYYY"
              type="month"
              range
              placeholder="Elija fecha"
            />
          </b-form-group>
        </b-col>
         -->

        <!-- Fecha de firma -->
        <b-col lg="3">
          <b-form-group label="Fecha de firma">
            <date-picker
              v-model="filtros.fechaFirmaContrato"
              class="filter"
              format="MM-YYYY"
              type="month"
              range
              placeholder="Elija fecha de firma"
            />
          </b-form-group>
        </b-col>

        <!-- Fecha primera versión -->
        <b-col lg="3">
          <b-form-group label="Fecha ofertas nuevas">
            <date-picker
              class="filter"
              v-model="filtros.fechaPrimeraVersion"
              format="MM-YYYY"
              type="month"
              @input="filtrar"
              range
              placeholder="Elija la fecha de ofertas nuevas"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </details>
  </div>
</template>
<script>
"use strict";

import { mapState, mapActions, mapWritableState } from "pinia";
import { useFiltrosOfertaFormStore } from "@/stores/FiltrosOfertaForm";
import { debounce } from "@/services/debounce";

export default {
  data() {
    return {
      opcionesCliente: [],
    };
  },
  computed: {
    ...mapState(useFiltrosOfertaFormStore, ["maestros", "filtrosAplicables"]),
    ...mapWritableState(useFiltrosOfertaFormStore, ["filtros"]),
  },
  methods: {
    ...mapActions(useFiltrosOfertaFormStore, ["resetFiltros"]),
    onUnidadesNegocioChanged() {
      if (this.filtros.paises.length || this.filtros.clienteId > 0 || this.filtros.propietarios.length) {
        this.filtros.paises = [];
        this.filtros.clienteId = null;
        this.filtros.propietarios = [];
        this.$messages.info("Al cambiar la unidad de negocio se vacían los filtros de pais, cliente y propietarios");
      }
    },
    filtrar() {
      this.$emit("filtrar");
    },
    filtrarDebounced: debounce(function () {
      this.filtrar();
    }, 300),
  },
  watch: {
    filtrosAplicables() {
      this.filtrarDebounced();
    },
  },
};
</script>
